
define('plugins/hbs/helpers/timeformat',['handlebars', 'moment'],
    function (handlebars, moment) {

        var timeFormat = function (dateTime, format) {
            if (arguments.length < 2) {
                throw new Error("Handlebars Helper 'timeFormat' needs at least 2 parameters");
            }

            var result = moment(dateTime).format(format);

            return result;
        };

        handlebars.registerHelper('timeformat', timeFormat);
        return timeFormat;
    }
);